import * as React from "react";
import { pipe } from "fp-ts/function";
import { option } from "fp-ts";
import { Button } from "@mui/material";
import { EventDetail } from "../../hooks/event";
import { Option } from "fp-ts/Option";
import { InternalLink } from "../common/Link";
import { orgRoute } from "../../routes/user";
import { Subdomain } from "../../utils/subdomain/subdomain";

interface Props {
    data: Option<EventDetail>;
    orgSubdomain: Option<Subdomain>;
}

export const EventBreadCrumbs = (p: Props) => {
    return pipe(
        p.data,
        option.map((data) => (
            <InternalLink
                href={orgRoute.events.detail.route({
                    eventId: data.id,
                    org: option.toNullable(p.orgSubdomain),
                })}
            >
                <Button>{data.title}</Button>
            </InternalLink>
        )),
        option.toNullable
    );
};
